export const forgivenessType = [
  {
    label: 'PSLF',
    value: 'pslf',
  },
  {
    label: 'TLF',
    value: 'tlf',
  },
  {
    label: 'IDR',
    value: 'idr',
  },
  {
    label: 'Closed School Discharge',
    value: 'closed_school_discharge',
  }
];

export const perkinsCancellation = {
  label: 'Perkins Cancellation',
  value: 'perkins_cancellation',
};
